<template>
    <rkm-modal
        ref="Modal"
        :title="unidadeId ? unidadeNome : `${vacinaNome} - Total: ${total}`"
        extra-large
    >
        <rkm-table
            :fields="fieldsUnidades"
            :items="unidades"
            hide-filters
            hide-pagination
            v-if="!unidadeId"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="setUnidade(item.unidadeId)"
                    color="primary"
                    small
                >
                    <rkm-icon icon="search" />
                </rkm-button>
            </template>
        </rkm-table>

        <rkm-table
            :fields="fieldsVacina"
            :items="vacinasUnidade"
            hide-filters
            hide-pagination
            v-else
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                @click="setUnidade()"
                color="secondary"
                v-if="unidadeId"
            >
                Voltar
            </rkm-button>

            <rkm-button
                @click=cancel
                color="secondary"
            >
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
export default {
    data: () => {
        return {
            unidades: [],
            vacinas: null,
            vacinaNome: null,
            unidadeNome: null,
            total: null,
            unidadeId: null,
        }
    },
    computed: {
        fieldsUnidades() {
            return [
                {
                    key: 'unidade',
                    label: 'Unidade'
                },
                {
                    key: 'estoque',
                    label: 'Estoque'
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        },
        fieldsVacina() {
            return [
                {
                    key: 'produtor',
                    label: 'Produtor'
                },
                {
                    key: 'lote',
                    label: 'Lote'
                },
                {
                    key: 'validade',
                    label: 'Validade'
                },
                {
                    key: 'estoque',
                    label: 'Estoque'
                },
            ]
        },
        vacinasUnidade() {
            return this.vacinas.filter(unidade => {
                return unidade.unidadeId == this.unidadeId
            })
        }
    },
    methods: {
        open(data) {
            this.unidadeId = null
            this.unidadeNome = null
            this.vacinas = data.entradas
            this.unidades = data.entradas.reduce((acc, curr) => {
                const index = acc.findIndex(obj => obj.unidade == curr.unidade)
                if(index == -1) {
                    acc.push(curr)
                } else {
                    const tmp = acc[index]
                    acc[index] = {
                        ...tmp,
                        estoque: tmp.estoque + curr.estoque
                    }
                }
                return acc
            }, [])
            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    this.vacinaNome = data.vacinaAbreviacao
                    break;
                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    this.vacinaNome = data.vacinaSigla
                    break;
                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    this.vacinaNome = data.vacinaSiglaNome
                    break;
                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    this.vacinaNome = data.vacinaSiglaAbreviacao
                    break;
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    this.vacinaNome = data.vacinaAbreviacaoNome
                    break;
                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    this.vacinaNome = data.vacinaSiglaAbreviacaoNome
                    break;
                default:
                    this.vacinaNome = data.vacinaNome
                    break;
            }
            this.total = data.total
            this.$refs.Modal.show()
        },
        setUnidade(id = null) {
            this.unidadeId = id
            if(id) {
                this.unidadeNome = this.vacinas.find(vacina => vacina.unidadeId == id).unidade
            } else {
                this.unidadeNome = null
            }
        }
    },
    props: {
        enums: { type: Object, required: true },
        additionals: { type: Object, required: true }
    }
}
</script>